import { render, staticRenderFns } from "./ObrasEditar.vue?vue&type=template&id=4eaf71b7&scoped=true&"
import script from "./ObrasEditar.vue?vue&type=script&lang=js&"
export * from "./ObrasEditar.vue?vue&type=script&lang=js&"
import style0 from "./ObrasEditar.vue?vue&type=style&index=0&id=4eaf71b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaf71b7",
  null
  
)

export default component.exports